export default __webpack_public_path__ + "static/media/SWT1010.34I-29581_-17088_0.e56ee934.jpg";